import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

type CommerceFeatureWorkspace = 'catalog-owner' | 'reseller';

interface CommerceFeatureUnavailableProps {
  workspace: CommerceFeatureWorkspace;
}

export function CommerceFeatureUnavailable({ workspace }: CommerceFeatureUnavailableProps) {
  const heading = workspace === 'reseller' ? 'Reseller' : 'Commerce';
  const intro =
    workspace === 'reseller'
      ? 'Reseller workspaces are currently disabled for this tenant.'
      : 'Commerce workspaces are currently disabled for this tenant.';
  const title = workspace === 'reseller' ? 'Reseller feature unavailable' : 'Commerce feature unavailable';
  const description =
    workspace === 'reseller'
      ? 'This tenant does not currently have reseller workspaces enabled. Ask a tenant administrator to enable the reseller feature if this tenant should access reseller catalogs, carts, quotes, orders, or commission reporting.'
      : 'This tenant does not currently have commerce administration enabled. Ask a tenant administrator to enable the commerce feature if this tenant should manage catalogs, pricing, publications, or ordering workspaces.';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{heading}</h1>
        <p className="text-sm text-muted-foreground">{intro}</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">{description}</p>
        </CardContent>
      </Card>
    </div>
  );
}
